<template>
    <div v-if="statusLoading == 'exist_data'" :class="['loading', !isStart || !store.plan_info.loading_screen ? 'content-mini-size' : '']">
        <vue-loading :loading="isLoading"></vue-loading>
        <div class="loading__header m-b-24">
            <h3 class="m-0"> {{$t('loading_screen.name')}} </h3>
            <template v-if="isStart">
                <template v-if="store.plan_info.loading_screen">
                    <!-- <div class="display-space-between align-items-center" v-if="isStart">
                        <span v-html="$t('loading_screen.description')"></span>
                        <a-tooltip :visible="exampleTooltip"
                            overlayClassName="example-tooltip"
                            :prefixCls="$prefixClass.tooltip"
                            placement="top">
                            <div class="example-tooltip__wrap" slot="title">
                                <span class="example-tooltip__content">{{ $t('loading_screen.watch_example') }}</span>
                                <i class="fal fa-times m-r" @click="hideExampleTooltip"></i>
                            </div>
                            <a class="a-link" @click="openModalWatchExample">
                                {{ $t('loading_screen.buttons.watch_example') }}
                                <i class="far fa-play-circle m-l-8"></i>
                            </a>
                        </a-tooltip>
                    </div>
                    <span v-else v-html="$t('loading_screen.start_description')"></span> -->
                    <span>
                        {{ $t('loading_screen.description') }}
                        <a class="a-link font-weight-normal" @click="exampleVideosVisible = true">{{$t('loading_screen.buttons.watch_example_videos')}}</a>
                    </span>
                </template>
                <span v-else class="text-color-secondary"> {{ $t('app.block_function.header_description') }}</span>
            </template>
        </div>
        <loading-screen-tutorial v-if="!isStart || !store.plan_info.loading_screen"
            :active="store.plan_info.loading_screen" start
            @let-start="letStart">
        </loading-screen-tutorial>
        <div v-else class="loading__settings">
            <vue-app-bar 
                :visible="appBar.isModify" 
                :type="appBar.typeTopBar"
                :text="appBar.text"
                @onSave="onSave" 
                @onCancel="onCancel">
            </vue-app-bar>
            <div class="loading__content" v-if="formStyle && formSettings">
                <div class="loading__content-left">
                    <div :class="[$prefixClass.card + '-stroke', 'active-loading']">
                        <a-switch v-model="formSettings.active" :prefixCls="$prefixClass.switch" @change="activeChanged = true"/>
                        <span class="m-l-8">Active loading screen</span>
                    </div>
                    <div v-if="componentEditting" :class="['loading__component-edit', $prefixClass.card + '-stroke']">
                        <div :class="[$prefixClass.link + '-nav', 'cursor-pointer m-b-10']" @click="componentEditting = ''">
                            <i class="fas fa-chevron-left m-r-8"></i>
                            <span>Back</span>
                        </div>
                        <percentage-counter v-if="componentEditting == 'formPercentage'" 
                            v-model="templateSelected.formPercentage"
                        ></percentage-counter>
                        <custom-image v-if="componentEditting == 'formCustomImage'" 
                            v-model="templateSelected.formCustomImage"
                        ></custom-image>
                        <progress-bar v-if="componentEditting == 'formProgressBar'"
                            v-model="templateSelected.formProgressBar"
                        ></progress-bar>
                        <loading-icon v-if="componentEditting == 'formLoadingIcon'"
                            v-model="templateSelected.formLoadingIcon"
                        ></loading-icon>
                        <loading-text v-if="componentEditting == 'formText'"
                            v-model="templateSelected.formText"
                        ></loading-text>
                    </div>
                    <div v-else :class="[$prefixClass.card + '-stroke', 'm-t-16']">
                        <a-tabs :prefixCls="$prefixClass.tabs" defaultActiveKey="section" :animated="false">
                            <a-tab-pane key="section" tab="Style">
                                <loading-style 
                                    v-model="formStyle"
                                    :listComponentSetting="listComponentSetting"
                                    @resetDefaultValue="resetDefaultValue"
                                    @editComponent="componentEditting = $event"
                                ></loading-style>
                            </a-tab-pane>
                            <a-tab-pane key="theme" tab="Settings">
                                <settings @runDemo="runDemo" v-model="formSettings"></settings>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
                <div class="loading__content-right">
                    <div class="loading__preview">
                        <div class="preview__header m-b-8">
                            <div class="preview__buttons">
                                <div class="d-flex">
                                    <a-button :class="['m-r-8 preview-btn', isDesktop ? 'btnActive' : 'btnInactive']" type="secondary" @click="isDesktop = true" >
                                        <i class="fas fa-desktop-alt"></i>
                                    </a-button>
                                    <a-button :class="['preview-btn', !isDesktop ? 'btnActive' : 'btnInactive']" type="secondary" @click="isDesktop = false">
                                        <i class="fas fa-mobile-alt"></i>
                                    </a-button>
                                </div>
                                <i class="fas fa-redo-alt font-weight-normal cursor-pointer" @click="runDemo"></i>
                            </div>
                            <span class="template-name">{{formStyle.template_active ? $t('loading_screen.' + formStyle.template_active) : 'Choose template'}}</span>
                        </div>
                        <div class="preview__content">
                            <div :class="['preview-loading', isDesktop ? 'desktop-preview' : 'mobile-preview']">
                                <img :src="isDesktop ? require('./../assets/thumnail.svg') : require('./../assets/mobile-thumnail.svg')"
                                    :class="['m-t-24', isDesktop ? 'm-b-24' : '']"/>
                                <template v-if="demo">
                                    <div class="background-wapper" v-if="templateSelected.background.type === 'color'" :style="{'background-color': background}">
                                        <p-main
                                            :value="formStyle"
                                            :time="formSettings.duration_time > timeDefault ? formSettings.duration_time : timeDefault"
                                            :percent="autoPercent"
                                            :isDisplay="formStyle.template_active ? true : false"
                                        ></p-main>
                                    </div>
                                    <template v-else>
                                        <img class="object-fit-cover background-wapper" :src="backgroundSrc || require('./../assets/no-img-background.svg')" alt=""/>
                                        <div class="background-wapper">
                                            <p-main
                                                :value="formStyle"
                                                :time="formSettings.duration_time > timeDefault ? formSettings.duration_time : timeDefault"
                                                :percent="autoPercent"
                                                :isDisplay="formStyle.template_active ? true : false"
                                            ></p-main>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="appBar.isModify" class="preview__actions m-t-32 text-right">
                        <a-button class="m-r-15" type="secondary" @click="onCancel">{{$t('app.buttons.cancel')}}</a-button>
                        <a-button type="primary" @click="onSave(null)">{{$t('app.buttons.save')}}</a-button>
                    </div>
                </div>
            </div>
            <modal-watch-demo v-model="exampleVideosVisible"></modal-watch-demo>
        </div>
        <!-- <vue-block-function v-else class="m-t-24"></vue-block-function> -->
    </div>
</template>

<script>
    import { store } from '@/main.js'
    import { mapGetters, mapActions } from 'vuex'
    import { types as typesLoading } from './../constant'
    import { loadingStyleDefault } from './../constant'
    import { loadingSettingsDefault } from './../constant'
    import { listComponentDefault } from './../constant'
    import { types as typesAuth } from '@/modules/auth/constant'
    import LoadingScreenTutorial from './../components/LoadingScreenTutorial'
    import ProgressBar from './../components/ProgressBar'
    import PercentageCounter from './../components/PercentageCounter'
    import CustomImage from './../components/CustomImage'
    import LoadingIcon from './../components/LoadingIcon'
    import LoadingText from './../components/LoadingText'
    import Settings from './../components/Settings'
    import LoadingStyle from './../components/LoadingStyle'
    import PMain from './../components/Preview/PMain'
    import includes from "lodash/includes";
    import cookie from 'js-cookie'
    import ModalWatchDemo from '../components/ModalWatchDemo'

    const TIME_DEFAULT = 3;
    var timeOutSession;
    var timeOutAmination;
    var autoProcess;
    export default {
        name: 'Loading',
        metaInfo: {
            title: 'Loading Screen'
        },
        components: {
            LoadingScreenTutorial,
            LoadingStyle,
            Settings,
            PMain,
            ProgressBar,
            PercentageCounter,
            CustomImage,
            LoadingIcon,
            LoadingText,
            ModalWatchDemo
        },
        beforeRouteLeave (to, from, next) {
            if( this.appBar.isModify ){
                this.confirmBeforeRouteLeaveCustom({next})
            }else{
                next()
            }
        },
        data() {
            return {
                isLoading: false,
                isSavingTooltip: false,
                exampleTooltip: false,
                loadData: false,
                componentEditting: '',
                timeDefault: TIME_DEFAULT,
                isStart: true,
                isDesktop: true,
                demo: false,
                data: null,
                formStyle: null,
                formSettings: null,
                autoPercent: 0,
                activeChanged: true,
                statusLoading: 'first_time',
                templateSelected: null,
                background: '',
                backgroundSrc: '',
                exampleVideosVisible: false,
                appBar: {
                    isModify: false,
                    typeTopBar: 'unsaved',
                    text: ''
                },
                listComponentSetting: []
            }
        },
        computed: {
            ...mapGetters({
                allLoadingSettings: typesLoading.getters.GET_ALL_SETTINGS,
                store : typesAuth.getters.GET_STORE,
                isShowMenuTooltip : 'getShowMenuTooltip',
            })
        },
        watch: {
            formStyle: {
                handler() {
                    if ( !this.loadData ) {
                        this.appBar.typeTopBar = "unsaved"
                        this.appBar.text = ""
                        this.appBar.isModify = true
                    }
                    this.featchData()
                    this.runDemo()
                },
                deep: true
            },
            formSettings: {
                handler() {
                    if ( !this.loadData ) {
                        this.appBar.typeTopBar = "unsaved"
                        this.appBar.text = ""
                        this.appBar.isModify = true
                    }
                    this.runDemo()
                },
                deep: true
            },
            isDesktop: {
                handler() {
                    this.runDemo()
                },
                deep: true
            }
        },
        async created() {
            let self = this
            this.loadData = true
            if ( !this.allLoadingSettings || !this.allLoadingSettings.style || !this.allLoadingSettings.settings ) {
                await this.getLoadingSettings()
            } else {
                this.mappingFormStyle(this.allLoadingSettings.style)
                this.formStyle = this.allLoadingSettings.style
                this.formSettings = this.allLoadingSettings.settings
            }
            this.statusLoading = "exist_data"
            this.exampleTooltip = cookie.get('example-tooltip-visible') != undefined
            setTimeout(() => { 
                this.loadData = false
                this.runDemo()
            })
        },
        methods: {
            ...mapActions({
                getAllLoadingSettings: typesLoading.actions.GET_ALL_SETTINGS,
                saveAllSettings: typesLoading.actions.SAVE_ALL_SETTINGS
            }),
            featchData() {
                if ( this.formStyle.template_active ) {
                    let src = ""
                    this.templateSelected = this.formStyle[this.formStyle.template_active]
                    if ( typeof(this.templateSelected.background.src) === 'object') {
                        src = this.templateSelected.background.src ? this.templateSelected.background.src.src : ''
                    } else {
                        src = this.templateSelected.background.src
                    }
                    this.backgroundSrc = src
                    this.background = this.templateSelected.background.color
                }
                
            },
            mappingFormStyle(formStyle) {
                for ( let element  in formStyle ) {
                    if ( typeof(formStyle[element]) === 'object') {
                        if ( !formStyle[element] ) {
                            formStyle[element] = {...formStyle[element], ...loadingStyleDefault[element]}
                        }
                        formStyle[element].background.src = formStyle[element].background.src ? formStyle[element].background.src : ""
                        formStyle[element].formCustomImage.isRepeat = formStyle[element].formCustomImage.isRepeat == 'true'
                        formStyle[element].formCustomImage.imgUrl = formStyle[element].formCustomImage.imgUrl ? formStyle[element].formCustomImage.imgUrl : ""
                        formStyle[element].formProgressBar.isUseStripeColor = formStyle[element].formProgressBar.isUseStripeColor == 'true'
                    }
                }
            },
            async getLoadingSettings() {
                this.isLoading = true
                let self = this
                await this.getAllLoadingSettings().then(res => {
                    let { status = false, data = null } = res.data
                    if (status) {
                        self.isStart = data.settings
                        let formSettings = data.settings ? data.settings : self.$clone(loadingSettingsDefault)
                        let formStyle = data.style ? data.style : self.$clone(loadingStyleDefault)
                        formSettings.active = data.settings && data.settings.active ? true : false
                        formSettings.page_show_specific = formSettings.page_show_specific && formSettings.page_show_specific.length > 0 ? formSettings.page_show_specific : []
                        self.mappingFormStyle(formStyle)
                        self.formSettings = formSettings
                        self.formStyle = formStyle
                    } else {
                        self.statusLoading = "no_data";
                        self.toastError({
                            title: "Error",
                            message: self.$t('app.errors.something_went_wrong'),
                            duration: 4
                        })
                    }
                    self.isLoading = false
                }).catch(e => {
                    self.isLoading = false
                    console.log(e);
                });
            },
            async letStart() {
                this.isLoading = true
                this.loadData = true
                await this.onSave()
                await this.getLoadingSettings()
                this.exampleTooltip = true
                cookie.set('example-tooltip-visible', true, { expires: 30 })
                this.loadData = false
            },
            resetDefaultValue() {
                let dataDefault = {
                    style: this.$clone(loadingStyleDefault[this.formStyle.template_active]),
                    settings: this.$clone(this.formSettings)
                }
                dataDefault.style.templateSelected = this.formStyle.template_active
                dataDefault.settings.active = dataDefault.settings.active ? 1 : 0
                this.isLoading = true
                this.onSave(dataDefault)
            },
            validateData(dataPost) {
                if ( this.isDisplayComponent('formCustomImage') && dataPost.style && !dataPost.style.formCustomImage.imgUrl ) {
                    this.appBar.typeTopBar = "error"
                    this.appBar.text = this.$t('loading_screen.errors.upload_image')
                    return false
                }
                if ( dataPost.settings.page_show_type === 'specific' && !dataPost.settings.page_show_specific.length > 0 ) {
                    this.appBar.typeTopBar = "error"
                    this.appBar.text = this.$t('loading_screen.errors.select_page')
                    return false
                }
                if ( (!dataPost.style || !dataPost.style.templateSelected) && dataPost.settings.active ) {
                    this.appBar.typeTopBar = "error"
                    this.appBar.text = this.$t('loading_screen.errors.select_template')
                    return false
                }
                return true
            },
            async onSave(dataPost=null) {
                let self = this
                let isReset = dataPost ? true : false
                if ( !isReset ) {
                    dataPost = {
                        style: this.templateSelected,
                        settings: this.$clone(this.formSettings)
                    }
                }
                if ( dataPost.style ) {
                    dataPost.style.templateSelected = this.formStyle.template_active
                }
                dataPost.settings.active = dataPost.settings.active ? 1 : 0
                let isValid = await this.validateData(dataPost)
                if ( isReset || isValid ) {
                    this.appBar.typeTopBar = 'saving'
                    await this.saveAllSettings(this.createFormData(dataPost)).then(res => {
                        let { status = false, data = null } = res.data
                        if (status) {
                            self.appBar.typeTopBar = 'save'
                            setTimeout(()=>{
                                self.onCancel()
                                if ( isReset ) {
                                    self.toastSuccess({
                                        title: this.$t('loading_screen.confirm.reset_sucessfully'),
                                        duration: 2
                                    });
                                }
                            }, 2000)

                            // Save cookie done preloading and show tooltip preloading screen
                            // Check show 
                            if (cookie.get('show-tooltip') != undefined && !this.isSavingTooltip) {
                                let showTooltip = JSON.parse(cookie.get('show-tooltip'));
                                if (showTooltip.perceived.isShowedTTPreloading != undefined && !showTooltip.perceived.isShowedTTPreloading) {
                                    showTooltip.perceived.showTTPreloading = true
                                    showTooltip.perceived.isShowedTTLoading = true
                                    
                                    cookie.set('show-tooltip', showTooltip, { expires: 1 })
                                    this.isSavingTooltip = true;
                                    let count = Number(this.isShowMenuTooltip);
                                    store.commit('setShowMenuTooltip', count + 1)
                                }
                            }
                        } else {
                            self.appBar.typeTopBar = 'error'
                            self.appBar.text = self.$t('app.errors.something_went_wrong')
                            if ( isReset ) {
                                self.toastError({
                                    title: "Error",
                                    message: self.$t('app.errors.something_went_wrong'),
                                    duration: 4
                                })
                            }
                        }
                    }).catch(e => {
                        console.log(e);
                    });
                }
            },
            async onCancel() {
                this.loadData = true
                await this.getLoadingSettings()
                this.appBar.isModify = false
                this.appBar.typeTopBar = 'unsaved'
                this.appBar.text = ''
                this.loadData = false
            },
            isDisplayComponent(component) {
                return this.templateSelected && includes(this.templateSelected.componentsDisplay, component)
            },
            setComponentsDisplay() {
                let templateActiveObj = this.templateSelected
                let myComponent = []
                for ( let index in templateActiveObj) {
                    let element = templateActiveObj[index]
                    if ( typeof(element) === 'object' && element.hasOwnProperty('positionIndex')) {
                        myComponent[element.positionIndex] = this.$clone(listComponentDefault.find(item => item.value === index))
                        myComponent[element.positionIndex].isDisplay = includes(templateActiveObj.componentsDisplay, index)
                    }
                }
                this.listComponentSetting = myComponent
            },
            async runDemo() {
                if ( !this.activeChanged && this.formStyle.template_active && !this.loadData) {
                    let self = this
                    let timeSession = this.formSettings && this.formSettings.duration_time > this.timeDefault ? this.formSettings.duration_time : this.timeDefault
                    await this.setComponentsDisplay()
                    let componentDisplay = this.listComponentSetting.filter(item => item.isDisplay)
                    clearTimeout(timeOutSession)
                    clearTimeout(timeOutAmination)
                    if ( componentDisplay.length > 0 && this.formStyle.template_active) {
                        this.demo = true
                        if ( this.isDisplayComponent('formProgressBar') || this.isDisplayComponent('formPercentage') ) {
                            this.progressBarInterval(timeSession)
                        }
                        timeOutSession = setTimeout(() => {
                            clearInterval(autoProcess)
                            let element = $(".background-wapper")
                            let aminationClass = 'swift-'+self.formSettings.animation_style+'-'+self.formSettings.delay_time
                            element.addClass(aminationClass)
                            timeOutAmination = setTimeout(() => {
                                element.removeClass(aminationClass)
                                self.demo = false
                            }, self.formSettings.delay_time*1000)
                        }, timeSession*1000)
                    } else {
                        this.demo = false
                    }
                }
                this.activeChanged = false
            },
            progressBarInterval(time) {
                clearInterval(autoProcess)
                this.autoPercent = 0
                autoProcess = setInterval(() => {
                    if (this.autoPercent < 100) {
                        this.autoPercent += 1
                    }
                    if(this.autoPercent >= 100){
                        clearInterval(autoProcess)
                    }
                }, 30)
            },
            hideExampleTooltip() {
                this.exampleTooltip = false
                cookie.remove('example-tooltip-visible')
            },
            openModalWatchExample() {
                this.modalWatchExampleVisible = true
                this.hideExampleTooltip()
            }
        }
    }
</script>
<style lang="scss">
    .example-tooltip {
        min-width: 245px;
        &__wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            font-weight: bold;
            color: $white-color;
            .fa-times {
                font-weight: bold;
                &:hover {
                    cursor: pointer;
                }
            }
        }
        .m-tooltip {
            &-inner {
                background: $text-color;
                padding: 10px 8px !important;
            }
            &-arrow:before {
                width: 12px;
                height: 12px;
                background: $text-color;
                transform: translateY(-9.53553px) rotate(45deg)
            }
        }
    }
    .loading {
        .m-card-stroke {
            padding: 16px;
        }
        .active-loading {
            padding: 16px 20px;
        }
        .video-info-wrap {
            width: 224px;
            height: 178px;
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            iframe {
                width: 100%;
                height: 100%;
            }
            .a-badge {
                position: absolute;
                height: 26px;
                width: 100px;
                background: $primary-color-light;
                border-color: $primary-color-light;
                border-radius: 0 2px 2px 0;
                top: 8px;
                font-size: 16px;
            }
        }
        &__header {
            .a-link {
                &:hover {
                    text-decoration: none;
                }
            }
        }
        &__component-edit {
            margin-top: 16px;
            padding: 24px;
            .m-select {
                width: 137px;
            }
            .a-form-item {
                display: flex;
                align-items: center;
                label {
                    margin-bottom: 0;
                }
                .a-col-12 {
                    > div {
                        float: right;
                    }
                }
            }
        }
        &__content {
            display: flex;
            &-left {
                min-width: 340px;
                max-width: 340px;
            }
            &-right {
                width: 100%;
            }
        }
        &__settings {
            .m-tabs {
                overflow: unset;
            }
        }
        &__preview {
            margin-left: 16px;
            padding: 16px;
            background: #DBE2EB;
            border-radius: 8px;
            .preview {
                &__buttons {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    z-index: 10;
                    button {
                        width: 34px;
                        height: 34px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0;
                        &.btnActive {
                            background-color: #fff !important;
                        }
                        &.btnInactive {
                            background-color: unset !important;
                        }
                    }
                }
                &__content {
                    overflow: hidden;
                }
                &__header {
                    display: flex;
                    align-items: center;
                    .template-name {
                        position: absolute;
                        width: 64%;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>